import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'iq-central-front-end-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent {
  isLoading: boolean = false;
  reportData: CourseReportData;

  constructor(private readonly router: Router, private location: Location) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.reportData = navigation?.extras.state as CourseReportData;
    } else {
      const savedData = localStorage.getItem('staffReport');
      if (savedData) {
        this.reportData = JSON.parse(savedData);
      }
    }
  }

  async downloadReport() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    try {
      const report = document.getElementById('report');
      if (!report) {
        return;
      }

      // Get the dimensions of the element
      const { width, height } = report.getBoundingClientRect();

      // Create canvas with better resolution
      const canvas = await html2canvas(report, {
        scale: 2, // Better quality
        useCORS: true, // Allow images from other domains
        logging: false,
        allowTaint: true,
      });

      // Calculate PDF dimensions (maintain aspect ratio)
      const orientation = width > height ? 'landscape' : 'portrait';
      const pdf = new jsPDF(orientation, 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const aspectRatio = width / height;

      let imgWidth = pdfWidth - 20; // 10mm margin on each side
      let imgHeight = imgWidth / aspectRatio;

      // Ensure it fits within the page
      if (imgHeight > pdfHeight - 20) {
        imgHeight = pdfHeight - 20;
        imgWidth = imgHeight * aspectRatio;
      }

      // Center the image on the page
      const x = (pdfWidth - imgWidth) / 2;
      const y = (pdfHeight - imgHeight) / 2;

      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
      pdf.save('report.pdf');
      this.isLoading = false;
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }

  goBack() {
    this.location.back();
  }
}

export interface CourseReportData {
  assessmentTaken: any[];
  averageScore: number;
  averageSessionDuration: number;
  courseCompletion: string;
  courseId: string;
  courseTitle: string;
  dateEnrolled: string;
  feedbackComment: string;
  feedbackRating: number | null;
  generatedBy: string;
  instructor: string;
  lastAccessed: string;
  modulesCompleted: string;
  reportGeneratedOn: string;
  totalTimeSpent: number;
}
